import { render, staticRenderFns } from "./productOrder.vue?vue&type=template&id=290a01d7&scoped=true"
import script from "./productOrder.vue?vue&type=script&lang=js"
export * from "./productOrder.vue?vue&type=script&lang=js"
import style0 from "./productOrder.vue?vue&type=style&index=0&id=290a01d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a01d7",
  null
  
)

export default component.exports